// extracted by mini-css-extract-plugin
export default {"container":"_d9751eb9","shippingDetailsContainer":"_681b5769","detailsLabel":"_9d3f2cba","shippingDetails":"_eeba940e"};